export const HEADER_HEIGHT = 50;
export const SIDEBAR_WIDTH = 210;
export const FOOTER_HEIGHT = 26;

export const INFINITY_SIDEBAR_WIDTH = 210;

export const INFINITY_MANAGE_PREFIX = "/infinity-manage";